import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);

  // Bun's HMR (v1.3.x) often wedges on an error overlay after a failed hot patch, so force a full reload (at most
  // once per 3s). Only fires on `bun:error`, so it never masks a runtime bug.
  import.meta.hot.on("bun:error", () => {
    const KEY = "bun:last-hmr-reload";
    const now = Date.now();
    const last = Number(sessionStorage.getItem(KEY) ?? "0");
    if (now - last < 3000) return;
    sessionStorage.setItem(KEY, String(now));
    location.reload();
  });
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
